import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-collapsible-card',
    templateUrl: './collapsible-card.component.html',
    styleUrl: './collapsible-card.component.scss',
    imports: [NgClass]
})
export class CollapsibleCardComponent {
  @Input() public isOpen = true;
  @Input() public cardTitle = '';

  protected toggle(): void {
    this.isOpen = !this.isOpen;
  }
}
